type QueryFn<ParamsType, ReturnType> = (params: ParamsType) => Promise<ReturnType>

export const retryApiRequest =
  <ParamsType, ReturnType>(queryFn: QueryFn<ParamsType, ReturnType>, maxRetries = 0) =>
    async (params: ParamsType): Promise<ReturnType> => {
      try {
        return await queryFn(params)
      } catch (error) {
        if (maxRetries === 0) throw error

        return await retryApiRequest(queryFn, maxRetries - 1)(params)
      }
    }
